import React, { PureComponent } from 'react';

import errorBoundary from '@ifeng/errorBoundary';
import PropTypes from 'prop-types';

const Left = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            // eslint-disable-next-line react/no-unused-prop-types
            content: PropTypes.object,
        };
        render() {
            return <div />;
        }
    },
);

export { Left };
export default Left;
